import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ConviviaLogoComponent } from '@core/component/convivia-logo/convivia-logo.component';
import { ScrollRevealDirective } from '@shared/directive/scroll-reveal/scroll-reveal.directive';
import { CookieConsentService } from '@core/service/cookie-consent.service';

@Component({
  selector: 'app-footer',
  imports: [ConviviaLogoComponent, ScrollRevealDirective, RouterLink],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  @Input() type: 'app' | 'main' = 'app';
  @Output() openDemo = new EventEmitter<void>();

  constructor(protected readonly cookieConsent: CookieConsentService) {}

  onOpenDemo(): void {
    this.openDemo.emit();
  }
}
